<template>
  <div class="wrapper">
    <div
      class="tags-forms"
      ref="input-toggle-dropdown"
      :style="{ width: input_width }"
    >
      <img class="icon" src="@/assets/icons/internship/location-grey.svg" />
      <gmap-autocomplete
        :placeholder="placeholder"
        @place_changed="setPlace"
        class="location-input"
        :options="{ fields: ['geometry', 'formatted_address', 'name'] }"
        :value="tag_text"
        spellcheck="false"
        autocomplete="off"
      ></gmap-autocomplete>

      <button class="btn-add">
        <img src="@/assets/icons/plus-blue.svg" />
      </button>
    </div>
    <div class="tags-widget" v-if="input_data.length > 0">
      <div class="tags-item" v-for="(item, index) in input_data" :key="index">
        <span>{{ item | validate }}</span>
        <button @click="removeItem(item, index)" class="close-btn">
          &times;
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { eventBus } from "@/main";
export default {
  name: "tags-widget",
  props: {
    placeholder: {
      type: String,
      default: "",
    },
    input_width: {
      type: String,
      default: "width: 50%;",
    },
  },
  data() {
    return {
      input_data: [],
      tag_text: "",
      show_tags_result: false,
      search_tags_result: [],
      location_list: [],
      inactive: false,
      selected_location_name: "",
      loading_location_list: false,
      show_location_list: false,
      locaction_widget: false,
      position: {
        lat: 0,
        lng: 0,
      },
      markers: [],
      place: null,
      location_name: "",
    };
  },
  computed: {},
  watch: {},
  mounted() {
    let vm = this;
    eventBus.$on("reset_filter", function (data) {
      vm.input_data = [];
    });
  },
  methods: {
    onUse(name, position) {
      let vm = this;
      if (vm.selected_location_name) {
        vm.addTag({ name: name, position: position });
      } else {
        this.$notify({
          group: "status",
          type: "warn",
          title: "Error message",
          text: "No selected location",
        });
      }
    },
    usePlace() {
      let vm = this;
      this.onUse(vm.selected_location_name, vm.position);
    },
    setPlace(place) {
      let vm = this;
      vm.place = place;
      if (vm.$hasKey(place, "geometry.location")) {
        vm.position = {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
        };
      }
      if (vm.$hasKey(place, "formatted_address")) {
        vm.selected_location_name = place.formatted_address;
      }
      vm.usePlace();
    },
    addTag(item) {
      let vm = this;
      if (item.name == "Göteborg") {
        item.name = "Gothenburg";
      }
      vm.input_data.push(item.name);
      vm.tag_text = "";
      vm.show_tags_result = false;
      vm.$emit("onSubmit", vm.input_data);
      vm.$emit("input", vm.input_data);
    },
    removeItem(item, index) {
      let vm = this;
      vm.input_data.splice(index, 1);
      vm.$emit("onSubmit", vm.input_data);
      vm.$emit("input", vm.input_data);
    },
  },
};
</script>

<style lang="scss">
.wrapper {
  .tags-forms {
    .location-input {
      width: 100%;
      height: 100%;
      padding: 0px 5px;
      border-radius: 5px;
      background: #fff;
      outline: none;
    }
  }
}
</style>


<style lang="scss" scoped>
$assets: "~@/assets";
.wrapper {
  border-radius: 5px;
  width: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;
  .tags-forms {
    border: 1px solid #ddd;
    display: flex;
    align-items: center;
    border-radius: 5px;
    padding: 2px 10px;
    width: 100%;
    height: 35px;
    position: relative;
    margin-bottom: 10px;
    .btn-add {
      border: none;
      outline: none;
      background: transparent;
      display: flex;
      align-items: center;
      img {
        width: 15px;
      }
    }
    .search-tags-result {
      position: absolute;
      top: 40px;
      width: 100%;
      height: 200px;
      overflow-y: auto;
      background: #fff;
      border-radius: 5px;
      box-shadow: 0px 0px 8px rgb(206, 206, 206);
      z-index: 9999;
      .tag-result-item {
        padding: 8px 10px;
        border-bottom: 1px solid rgb(240, 240, 240);
        cursor: pointer;
        &:hover {
          background: rgb(240, 240, 240);
        }
      }
    }
  }

  .tags-widget {
    display: flex;
    flex-wrap: wrap;
    min-height: 47px;
    align-items: center;
    overflow-y: auto;
    margin-bottom: 8px;
    max-height: 300px;
    overflow-y: auto;
    width: 100%;
    .tags-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: #ebebeb;
      margin-right: 5px;
      margin-bottom: 5px;
      cursor: pointer;
      color: #000;
      border-radius: 20px;
      span {
        font-size: 13px;
        padding: 4px 20px;
        text-transform: capitalize;
      }
      .close-btn {
        background: #a51b1b;
        color: #fff;
        height: 15px;
        width: 15px;
        font-size: 17px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
</style>